(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wmr-cart-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const consentRoot = document.querySelector('[data-wmr-cart-consent]');
    if (!consentRoot) return;

    const terms = consentRoot.querySelector('[data-wmr-consent-terms]');
    const digital = consentRoot.querySelector('[data-wmr-consent-digital]');
    const eventConsent = consentRoot.querySelector('[data-wmr-consent-event]');
    const error = consentRoot.querySelector('[data-wmr-consent-error]');
    const requiresDigital = consentRoot.dataset.requiresDigital === 'true';
    const requiresEvent = consentRoot.dataset.requiresEvent === 'true';
    let submitting = false;

    consentRoot.querySelectorAll('[data-wmr-consent-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', (toggleEvent) => {
        toggleEvent.preventDefault();
        toggleEvent.stopPropagation();
        const detail = toggle.parentElement.querySelector('[data-wmr-consent-detail]');
        if (!detail) return;
        detail.hidden = !detail.hidden;
        toggle.textContent = detail.hidden ? 'Details' : 'Weniger';
      });
    });

    const valid = () =>
      Boolean(terms && terms.checked) &&
      (!requiresDigital || Boolean(digital && digital.checked)) &&
      (!requiresEvent || Boolean(eventConsent && eventConsent.checked));

    const saveConsent = async () => {
      const timestamp = new Date().toISOString();
      const version = consentRoot.dataset.consentVersion;
      const attributes = {
        'Einwilligung AGB und Datenschutz': 'Ja | ' + timestamp + ' | ' + version,
        'Einwilligung Textversion': version
      };

      if (requiresDigital) {
        attributes['Ausdrücklicher digitaler Leistungsbeginn'] = 'Ja | ' + timestamp + ' | ' + version;
        attributes['Bestätigung Verlust Widerrufsrecht digital'] = 'Ja | ' + timestamp + ' | § 356 Abs. 5 BGB';
      }

      if (requiresEvent) {
        attributes['Bestätigung kein Widerrufsrecht Termin'] =
          'Ja | ' + timestamp + ' | § 312g Abs. 2 Nr. 9 BGB | ' + version;
        attributes['Bestätigte Terminprodukte'] = consentRoot.dataset.eventProducts;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });

      if (!response.ok) throw new Error('Consent could not be stored');
    };

    const refuse = () => {
      error.hidden = false;
      consentRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    // Express buttons (Shop Pay, PayPal, Google Pay, Apple Pay) live inside
    // cross-origin iframes and cannot be intercepted. A transparent shield on
    // top of them catches the click until the boxes are ticked.
    let shield = null;
    const expressWrapper = document.querySelector('.additional-checkout-buttons');
    if (expressWrapper) {
      expressWrapper.style.position = 'relative';
      shield = document.createElement('button');
      shield.type = 'button';
      shield.className = 'wmr-consent-shield';
      shield.setAttribute('aria-label', 'Bitte bestätige zuerst die Erklärungen');
      shield.addEventListener('click', (shieldEvent) => {
        shieldEvent.preventDefault();
        shieldEvent.stopPropagation();
        refuse();
      });
      expressWrapper.appendChild(shield);
    }

    const paintState = () => {
      const ok = valid();
      document.body.classList.toggle('wmr-consent-locked', !ok);
      if (shield) shield.hidden = ok;
      if (ok) error.hidden = true;
    };

    consentRoot.addEventListener('change', () => {
      paintState();
      // Store the consent as soon as it is given, so the express payment
      // paths carry it too even though they never touch our checkout handler.
      if (valid()) saveConsent().catch(() => {});
    });

    paintState();

    document.addEventListener(
      'click',
      async (clickEvent) => {
        const checkout = clickEvent.target.closest(
          'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
        );
        if (!checkout || submitting) return;
        clickEvent.preventDefault();
        clickEvent.stopImmediatePropagation();

        if (!valid()) {
          refuse();
          return;
        }

        error.hidden = true;
        submitting = true;
        checkout.setAttribute('aria-busy', 'true');

        try {
          await saveConsent();
          window.location.assign('/checkout');
        } catch (_error) {
          submitting = false;
          checkout.removeAttribute('aria-busy');
          error.textContent = 'Die Bestätigung konnte nicht gespeichert werden. Bitte versuche es erneut.';
          error.hidden = false;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmr-legal-rail"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const checkoutLink = event.target.closest('a[href*="/checkout"]');
    if (!checkoutLink || window.location.pathname === '/cart') return;
    event.preventDefault();
    window.location.assign('/cart');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wmr-product-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-wmr-buy-consent]');
    if (!root) return;

    const terms = root.querySelector('[data-wmr-buy-terms]');
    const digital = root.querySelector('[data-wmr-buy-digital]');
    const eventBox = root.querySelector('[data-wmr-buy-event]');
    const error = root.querySelector('[data-wmr-buy-error]');
    const needsDigital = root.dataset.requiresDigital === 'true';
    const needsEvent = root.dataset.requiresEvent === 'true';
    let busy = false;

    // The theme adds to cart through its own delegated handler bound via the
    // on:click attribute. We take that over completely so the button can never
    // fire the theme's "added" animation without the consent being stored.
    // The button keeps type="submit": if this script ever fails to run, the
    // browser falls back to the plain form post and the old cart flow.
    const takeOverButtons = () => {
      document
        .querySelectorAll('form[data-type="add-to-cart-form"] button[name="add"]')
        .forEach((button) => button.removeAttribute('on:click'));
    };
    takeOverButtons();
    new MutationObserver(takeOverButtons).observe(document.body, { childList: true, subtree: true });

    root.querySelectorAll('[data-wmr-buy-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        const detail = toggle.parentElement.querySelector('[data-wmr-buy-detail]');
        if (!detail) return;
        detail.hidden = !detail.hidden;
        toggle.textContent = detail.hidden ? 'Details' : 'Weniger';
      });
    });

    const isValid = () =>
      Boolean(terms && terms.checked) &&
      (!needsDigital || Boolean(digital && digital.checked)) &&
      (!needsEvent || Boolean(eventBox && eventBox.checked));

    const paintState = () => {
      document.body.classList.toggle('wmr-buy-locked', !isValid());
      if (isValid()) {
        error.hidden = true;
        root.classList.remove('wmr-buy-consent--invalid');
      }
    };

    root.addEventListener('change', paintState);
    paintState();

    // `reset` is used when this purchase starts from an empty cart: every
    // confirmation that does not apply is written as an empty string, which
    // removes it, so no stale confirmation from an earlier cart survives.
    const consentAttributes = (reset) => {
      const stamp = new Date().toISOString();
      const version = root.dataset.consentVersion;
      const attributes = {
        'Einwilligung AGB und Datenschutz': 'Ja | ' + stamp + ' | ' + version,
        'Einwilligung Textversion': version
      };

      if (needsDigital) {
        attributes['Ausdrücklicher digitaler Leistungsbeginn'] = 'Ja | ' + stamp + ' | ' + version;
        attributes['Bestätigung Verlust Widerrufsrecht digital'] = 'Ja | ' + stamp + ' | § 356 Abs. 5 BGB';
      } else if (reset) {
        attributes['Ausdrücklicher digitaler Leistungsbeginn'] = '';
        attributes['Bestätigung Verlust Widerrufsrecht digital'] = '';
      }

      if (needsEvent) {
        const label = root.dataset.productTitle + ' – ' + (root.dataset.eventDate || '');
        attributes['Bestätigung kein Widerrufsrecht Termin'] =
          'Ja | ' + stamp + ' | § 312g Abs. 2 Nr. 9 BGB | ' + version;
        attributes['Bestätigte Terminprodukte'] = label;
      } else if (reset) {
        attributes['Bestätigung kein Widerrufsrecht Termin'] = '';
        attributes['Bestätigte Terminprodukte'] = '';
      }

      return attributes;
    };

    const refuse = () => {
      error.hidden = false;
      root.classList.add('wmr-buy-consent--invalid');
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    document.addEventListener(
      'click',
      async (clickEvent) => {
        const trigger = clickEvent.target.closest('button[name="add"], .add-to-cart-button');
        if (!trigger || busy) return;

        const form = trigger.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;

        clickEvent.preventDefault();
        clickEvent.stopImmediatePropagation();

        if (!isValid()) {
          refuse();
          return;
        }

        busy = true;
        trigger.setAttribute('aria-busy', 'true');

        try {
          let startsEmpty = false;
          try {
            const current = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
            startsEmpty = current.item_count === 0;
          } catch (_ignored) {
            startsEmpty = false;
          }

          const added = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!added.ok) throw new Error('add failed');

          const stored = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: consentAttributes(startsEmpty) })
          });
          if (!stored.ok) throw new Error('attributes failed');

          window.location.assign('/checkout');
        } catch (_e) {
          busy = false;
          trigger.removeAttribute('aria-busy');
          error.textContent = 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';
          error.hidden = false;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
